/* fb-rimg.js — Empire-free LAZY loader for the theme's `rimg` images.

   The theme renders images as `data-rimg="lazy"` (a placeholder until JS swaps the real
   image in) plus a grey `<div data-rimg-canvas>`. Empire's bundle did this lazily via an
   observer; with Empire gated off on the homepage we do the same here.

   Uses IntersectionObserver so each image loads just before it scrolls into view. Two wins
   over loading everything on DOMContentLoaded:
   - `display:none` elements (e.g. the cuadrícula's theme-editor card images, which we replace
     with a CSS `::before`) have NO layout box → never intersect → never downloaded. Previously
     they were fetched anyway (a hidden <img> still downloads when you set its src) — ~0.6–1 MB
     of waste on the homepage.
   - below-the-fold images defer until the user scrolls near them.

   On intersect: build the real URL from `data-rimg-template` (a `{size}` token) + `data-rimg-max`,
   set it, and flip `data-rimg="loaded"` — theme.css then fades the image in (opacity:1) and
   hides the adjacent `[data-rimg-canvas]`. Loaded only where Empire is off (see static-header). */
(function () {
  'use strict';

  function realSize(width, maxW, maxH) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.ceil((width || maxW) * dpr);
    if (!w || w > maxW) w = maxW;
    var h = Math.max(1, Math.round(w * (maxH / maxW)));
    return w + 'x' + h;
  }

  function apply(el, width) {
    if (el.getAttribute('data-rimg') === 'loaded') return;

    var tpl = el.getAttribute('data-rimg-template');
    var max = (el.getAttribute('data-rimg-max') || '').split('x');
    var maxW = parseInt(max[0], 10);
    var maxH = parseInt(max[1], 10);

    if (tpl && maxW && maxH) {
      var url = tpl.replace('{size}', realSize(width, maxW, maxH));
      if (el.tagName === 'IMG') {
        el.setAttribute('srcset', url);
        el.setAttribute('src', url);
      } else {
        el.style.backgroundImage = "url('" + url + "')";
      }
    } else if (el.tagName === 'IMG') {
      el.removeAttribute('srcset'); // no template — fall back to the real src already on the img
    }

    el.setAttribute('data-rimg', 'loaded'); // theme.css: opacity:1 + hides [data-rimg-canvas]
  }

  function run() {
    var nodes = document.querySelectorAll('[data-rimg="lazy"]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback (very old browsers): load only elements that have a layout box,
      // which still skips the display:none waste.
      var vis = [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getClientRects().length) vis.push(nodes[i]);
      }
      var ws = vis.map(function (n) { return n.offsetWidth || 0; });
      vis.forEach(function (n, k) { apply(n, ws[k]); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      // read all widths first, then write — keeps a batch of intersections from thrashing layout
      var hit = [];
      for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) hit.push(entries[i].target);
      var widths = hit.map(function (t) { return t.offsetWidth || 0; });
      hit.forEach(function (t, k) { apply(t, widths[k]); io.unobserve(t); });
    }, { rootMargin: '300px 0px' }); // start loading ~300px before it enters the viewport

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
